<div formGroupName="cndt">
    <mat-accordion class="expantion-style">
        <mat-expansion-panel class="mat-expansion-panel" [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title class="title">検索条件</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center"
                style="width: 500px;">
                <mat-form-field appearance="outline" floatLabel="always" style="width: 510px;">
                    <mat-label>督促管理区分</mat-label>
                    <input matInput style="display: none!important" formControlName="pressManagementdivisionList">
                    <mat-selection-list formControlName="pressManagementdivisionList" class="tw-flex tw-flex-row tw-flex-wrap
                      tw-box-border tw-justify-start tw-items-center tw-content-center
                      tw-grow tw-shrink tw-basis-[510px]  tw-max-w-[510px] tw-min-w-[510px]" floatLabel="always"
                        style="display:flex;">
                        <mat-list-option *ngFor="let status of codeConversionMstMap?.get('S300090')"
                            [value]="status.userCode"
                            (selectedChange)="getControl('pressManagementdivisionList')?.markAsTouched()"
                            class="mat-list-option" color="primary" checkboxPosition="before">
                            {{status.hyojiCont}}
                        </mat-list-option>
                    </mat-selection-list>
                </mat-form-field>
                <div class="tw-flex tw-flex-row" style="width: 600px;">
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%]">
                        <mat-label>会社</mat-label>
                        <mat-select formControlName="companycode" color="primary" (selectionChange)="onChangeCompany()">
                            <mat-option [value]="null"></mat-option>
                            <mat-option *ngFor="let div of companyList" [value]="div.value">{{div.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%]">
                        <mat-label>督促管理地区</mat-label>
                        <mat-select id="pressManageAreacode" formControlName="pressManageAreacode">
                            <mat-option [value]="null"></mat-option>
                            <mat-option *ngFor="let div of pressManageAreaList" [value]="div.value">{{div.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="tw-flex tw-flex-row" style="width: 600px;">
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%]">
                        <mat-label>料金区分</mat-label>
                        <mat-select formControlName="chargeDivcd">
                            <mat-option [value]="null"></mat-option>
                            <mat-option *ngFor="let div of chargeDivList" [value]="div.value">{{div.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center tw-gap-1.5"
                style="display:flex;">
                <mat-card-actions class="btn_area_right expansion-panel-actions">
                    <button type="submit" [disabled]="searchConditionForm.invalid" mat-raised-button color="primary"
                        class="btn">検索</button>
                </mat-card-actions>
                <mat-card-actions class="btn_area_right expansion-panel-actions">
                    <button type="button" mat-raised-button color="primary" class="btn"
                        (click)="onClickClear()">クリア</button>
                </mat-card-actions>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>